__turbopack_context__.v({
  "Contact": "PGlSyG_Contact",
  "contactHeading": "PGlSyG_contactHeading",
  "section": "PGlSyG_section",
  "text": "PGlSyG_text",
  "textWrapper": "PGlSyG_textWrapper",
});
